// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkinOutlinedSvg from "@ant-design/icons-svg/es/asn/SkinOutlined";
import AntdIcon from '../components/AntdIcon';

var SkinOutlined = function SkinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkinOutlinedSvg
  }));
};

SkinOutlined.displayName = 'SkinOutlined';
export default /*#__PURE__*/React.forwardRef(SkinOutlined);